import { transformErrorResponse } from "../../transformErrorResponse"
import { FilesDocDTO, Peru9112FibramasENTITY } from "sigo-entities"
import { AtcApiBuilder } from "."

export const PERU_9112_FibramasOrder = (build: AtcApiBuilder) => {
    return {
        getByIdFibramasOrders: build.query<Peru9112FibramasENTITY[], string>({
            query: (userId) => `procesos/PERU_9112_FibramasOrder/${userId}`,
            providesTags: (result, error, userId) =>
                result
                    ? [
                        // tag individual por cada orden
                        ...result.map((order) => ({
                            type: 'FibramasOrders' as const,
                            id: order._id,
                        })),
                        // y un tag general de la lista de ese usuario
                        { type: 'FibramasOrders' as const, id: `USER-${userId}` },
                    ]
                    : [{ type: 'FibramasOrders' as const, id: `USER-${userId}` }],
            transformErrorResponse
        }),
        getTransitFibramasOrders: build.query<{ transito: number }, { id_recurso: string, codigo: number }>({
            query: ({ id_recurso, codigo }) => `procesos/PERU_9112_FibramasOrder/calculate-transit/${id_recurso}/${codigo}`,
            transformErrorResponse
        }),
        addInventoryFibramasOrders: build.mutation<Peru9112FibramasENTITY, { id: string, body: { ID_StockPersonal: number, cantidad: number, Serie?: { Serie: string, ID_StockPersonalEquipos: number } } }>({
            query: ({ body, id }) => ({
                url: `procesos/PERU_9112_FibramasOrder/add-inventory/${id}`,
                method: "PUT",
                body,
            }),
            invalidatesTags: (result, error, { id }) => [
                { type: 'FibramasOrders' as const, id },
            ],
            transformErrorResponse
        }),
        deleteInventoryFibramasOrders: build.mutation<Peru9112FibramasENTITY, { id: string, codigo: number, serie: string }>({
            query: ({ id, codigo, serie }) => ({
                url: `procesos/PERU_9112_FibramasOrder/delete-inventory/${id}/${codigo}?serie=${serie}`,
                method: "PUT",
            }),
            invalidatesTags: (result, error, { id }) => [
                { type: 'FibramasOrders' as const, id },
            ],
            transformErrorResponse
        }),
        finalizeFibramasOrders: build.mutation<Peru9112FibramasENTITY, { id: string }>({
            query: ({ id }) => ({
                url: `procesos/PERU_9112_FibramasOrder/finalize/${id}`,
                method: "PUT"
            }),
            invalidatesTags: (result, error, { id }) => [
                // invalida la orden puntual
                { type: 'FibramasOrders' as const, id },
                // y también la lista del usuario (para que se refresque)
                // { type: 'WINOrders' as const, id: `USER-${userId}` },
            ],
            transformErrorResponse
        }),
        uploadPhotosFibramasOrders: build.mutation<Peru9112FibramasENTITY, { id: string, boletin: FilesDocDTO }>({
            query: ({ boletin, id }) => ({
                url: `procesos/PERU_9112_FibramasOrder/upload-files/${id}`,
                method: "PUT",
                body: { boletin },
            }),
            invalidatesTags: (result, error, { id }) => [
                { type: 'FibramasOrders' as const, id },
            ],
            transformErrorResponse
        }),
    }
}